"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareClassServiceStub = void 0;
const faker = __importStar(require("faker"));
class ShareClassServiceStub {
    async getShareClasses(companyId) {
        const total = faker.random.number({ min: 2, max: 5 });
        const classes = [];
        for (let i = 0; i < total; i += 1) {
            classes.push({
                _id: faker.random.alphaNumeric(),
                companyId,
                name: faker.random.alphaNumeric(),
                shareClassCode: faker.random.alphaNumeric(4),
                pricePerShare: faker.random.number(),
                effectiveFrom: faker.date.past(),
            });
        }
        return { status: true, message: "", payload: classes };
    }
    async getShareholderHoldingForShareClass(companyId, shareholderId, shareClassId) {
        if (companyId && shareholderId && shareClassId) {
            return {
                status: true,
                message: "",
                payload: {
                    _id: faker.random.alphaNumeric(),
                    totalQuantity: faker.random.number(),
                    totalAmountPaid: faker.random.number(),
                    totalAmountUnpaid: faker.random.number(),
                },
            };
        }
        return {
            status: false,
            message: "Invalid request",
            payload: null,
        };
    }
}
exports.ShareClassServiceStub = ShareClassServiceStub;
//# sourceMappingURL=ShareClassServiceStub.js.map